/* globals cpac, $, $j, userProfile, saveFormData, my_isset, toggleEditForm, updateProfileMainInfo, cardConnectFrameDialogServiceBillingInfo, i4goFrameDialogServiceBillingInfo, TakePayment, CcSwipeCatcher, showAjaxStarted, Ajax, showModalForm, showAjaxFinished, showResponse, reportAjaxError, AutoComplete, Windows, Effect, $$ */

if (typeof cpac !== 'undefined') {
    var resourcesPropertiesForm, ajaxDiv;

    cpac.user = {
        // profile-personal
        personal : {},
        // profileMembership
        membership: {},
        // profileBilling
        billing: {
            trackCatcher: null  //for swipe credit card
        },
        // Statement Tab
        statement: {},
        // Staff Information
        staffinfo: {}
    }
    
    cpac.user.personal.onPhoneOver = function(label) {
        try {

            var ua = navigator.userAgent.toLowerCase();
            var browser = /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
                /(opera)(?:.*version)?[ \/]([\w.]+)/.exec( ua ) ||
                /(msie) ([\w.]+)/.exec( ua ) ||
                !/compatible/.test( ua ) && /(mozilla)(?:.*? rv:([\w.]+))?/.exec( ua ) ||
                [];
        
            var leftOffset = 25;
            if( browser[1] == 'msie' && browser[2] < 8 ) {
                leftOffset += 35;
            }
        
            var offsets = $(label).positionedOffset();
            var top     = offsets[1];
            var left    = offsets[0] - leftOffset;
            var star    = $('profile-personal-phone-star');
            var field   = $('profile-personal-phone-star-field');
            var form    = $('personalEdit').down('form');
        
            if( !star && $('personalEdit')) {
                star = new Element('div', {id: 'profile-personal-phone-star'});
                star.addClassName('profile-personal-phone-star');
                form.insert(star);
            }
        
            star.stopObserving('click');
            star.observe('click', function(){
                new Effect.Shake(star, {distance: 2, duration: 0.333});
                if( !field ) {
                    field = new Element('input', {type: 'hidden', name: 'primaryPhone', id: 'profile-personal-phone-star-field'});
                    form.insert(field);
                }
        
                if( field.getValue() && field.getValue() != '' ) {
                    // var lbl = form.down('label[for='+field.getValue()+']'); prototype doesn't doing it in ie8
                    var lbl = $( $j('#personalEdit > form label[for='+field.getValue()+']')[0] ); // jquery does
                    if( lbl ) {
                        lbl.removeClassName('active');
                    }
                }
        
                field.setValue($(label).readAttribute('for'));
                $(label).addClassName('active');
            });
        
            if( star ) {
                star.setStyle({
                    top: top+'px'
                    ,left: left+'px'
                });
            }
        } catch(e) {
            cpac.error(e);
        }
    }

    cpac.user.statement.goToDate = function( _date ) {
        var form = $('filterForm');
        var url = form.action;
    
        var divID = 'statement-parent-container';
    
        var selectDateRow = $('filter[period]_row_'+_date);
        if( selectDateRow ) {
            var onclick = selectDateRow.getAttribute('onclick');
            if( onclick ) {
                (function(context, callback){
                    callback.call( context )
                })(selectDateRow, function(){
                    eval( onclick );
                });
                return;
            }
        }
    
    
        resourcesPropertiesForm = form;
        var formData = form ? $(form).serialize(true) : {};
        formData['filter[period]'] = _date;
    
        url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
        if( $('linked-child-accounts') && $F('linked-child-accounts') == -1 ) {
            url += '&view-all-on-account=1';
        }
        showAjaxStarted();
    
    
        ajaxDiv = $(divID);
        new Ajax.Request( url, {
            method: 'post',
            parameters: formData,
            onComplete: function(request) {
                showResponse(request, ajaxDiv);
            },
            onFailure: reportAjaxError
        });
    }
    

  cpac.user.personal.updateHeader = function() {
    var isCombined = $j('#profile-main-info').data('isCombined');
    var userId = $j('#profile-main-info').data('userId');
    $j.caPost('/user/update-header', {'id': userId, 'isCombined': isCombined}, function(response) {
        if (response.status == 1) {
            $j('#profile-main-info').html(response.content);
            userProfile.updateLiablilityWaiverBanner();
        } else {
            $j.caAlert(response.message);
        }
    }, 'json');
  }

  cpac.user.membership.editContract = function(title, gid, uid){
	var win = new Window({
		className: 'alphacube',
		title: title,
		width: 330,
		height: 100,
		closable: true,
		resizable: false,
		minimizable: false,
		maximizable: false,
		destroyOnClose: true
	});

    var start_date = $("contract"+gid+"_start_date").value;
    var month_count = $("contract"+gid+"_month_count").value;
    var fee = $("contract"+gid+"_fee").value;

    win.getContent().insert([
        '<div class="membership-contract">',
            '<div class="label">Start date: </div>',
            '<input type="text" class="field date" id="contract_start_date" value="'+start_date+'" />',
            '<input type="button" class="calendar-icon" onclick="displayCalendar( $(\'contract_start_date\'), \'mm/dd/yyyy\', this)" />',
            '<div class="label">Month count: </div>',
            '<input type="text" class="field month" id="contract_month_count" value="'+month_count+'" />',
            '<div class="label">Fee: </div>',
            '<input type="text" class="field fee" id="contract_fee" value="'+fee+'" />',
            '<input type="button" class="button nicebutton" value="Ok" onClick="cpac.user.membership.saveContract('+gid+', \''+win.getId()+'\', '+uid+')" />',
        '</div>'
    ].join(''));

    win.showCenter(true);
}

cpac.user.membership.saveContract = function( gid, wid, uid ) {
    var start_date = $('contract_start_date').value;
    var month_count = parseInt( $('contract_month_count').value );
    var fee = parseInt( $('contract_fee').value );

    if( ! /\d{2}\/\d{2}\/\d{4}/.test( start_date )) {
        $('contract_start_date').value = '';
    }else
    if( isNaN(month_count) || month_count <= 0 ) {
        $('contract_month_count').value = '';
    } else
    if( isNaN(fee) || fee <= 0 ) {
        $('contract_fee').value = '';
    } else {
        var cid = parseInt( $('contract'+gid+'_id').value );
        if( isNaN( cid )) {
            cid = '';
        }

		showAjaxStarted();
		var blockToUpdate = $('membershipEdit').up();
		new Ajax.Updater({success: blockToUpdate}, '/user/profile-membership?ajax=1', {
			method:'post',
			evalScripts: true,
			parameters: {
                 add_contract: 1
                ,id: uid
                ,group_id: gid
                ,start_date: start_date
                ,month_count: month_count
                ,fee: fee
                ,contract_id: cid
            },
			onSuccess: function(){
				showAjaxFinished();
			},
			onFailure: function(transport){
				reportAjaxError(transport);
			}
		});

        Windows.close( wid );
    }
}

cpac.user.membership.deleteContract = function( gid, uid ) {
    showAjaxStarted();
    var blockToUpdate = $('membershipEdit').up();
    new Ajax.Updater({success: blockToUpdate}, '/user/profile-membership?ajax=1', {
        method:'post',
        evalScripts: true,
        parameters: {
             remove_contract: 1
            ,id: uid
            ,group_id: gid
        },
        onSuccess: function(){
            showAjaxFinished();
        },
        onFailure: function(transport){
            reportAjaxError(transport);
        }
    });
}

cpac.user.membership.linkedAutocomplete = function (inputObj, groupId) {
    var options = {
          shownoresults: true,
          script: function (input) {return ('/user/auto?input='+input);},
          callback: function (obj) {
            cpac.user.membership.addLinked(obj.id, obj.value, groupId);
          },
          highlightInactive: true,
          allowedStatuses: ['Active']
    };
    var xml = new AutoComplete(inputObj, options);
    return true;
    }

    cpac.user.membership.addLinked = function (userId, userName, groupId) {
        var inputObj = $('linked_input-' + groupId);
        var li = inputObj.parentNode;
        var ul = li.parentNode;

        // if already has this member - return;
        var liId = 'li-' + groupId + '-' + userId;
        if (!$(liId)) {
            // add li and place input value to this new li
            var newLi = document.createElement('li');
            newLi.className = 'bit-box';
            newLi.innerHTML = userName;
            newLi.id = 'li-' + groupId + '-' + userId;
            newLi.setAttribute('onmouseover', "Element.addClassName(this, 'bit-hover')");
            newLi.setAttribute('onmouseout', "Element.removeClassName(this, 'bit-hover')");

            var a = document.createElement('a');
            a.className = 'closebutton';
            a.href = 'javascript:void(0)';
            a.setAttribute('onclick', 'this.parentNode.parentNode.removeChild(this.parentNode)');
            newLi.appendChild(a);

            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'linked_members[' + groupId + '][' + userId + ']';
            input.value = userId;
            newLi.appendChild(input);

            $(ul).insertBefore(newLi, li);
        }

        inputObj.value = '';

    }
  
  cpac.user.membership.saveMembership = function (form, url, divID, successCallback, extraData, silent, requestMethod) {
      if(!successCallback || successCallback == 'undefined') successCallback = function() { };
      resourcesPropertiesForm = form;
      var formData = form ? $(form).serialize() : '';
      if (my_isset(extraData)) {
          formData = formData + '&' + extraData;
      }
      url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
      if( !silent ) {
          showAjaxStarted();
      }
      if (requestMethod == undefined || !requestMethod)  {
          requestMethod = 'post';
      }

      ajaxDiv = $(divID);
      new Ajax.Request(
              url,
              {
                  method: requestMethod,
                  parameters: formData,
                  onComplete: function(request) {
                      var str = request.responseText;
                      if (str.indexOf('ASNH&*Db3211teawe8ADNAW*eajfhg') >= 0) {
                          var container = document.createElement('div');
                          container.innerHTML = str;
                          showModalForm('Membership change', container, 740, 300, true, { });
                          showAjaxFinished();
                          //$('user1').show();
                      }
                      else {
                          showResponse(request, ajaxDiv);
                      }
                  },
                  onFailure: reportAjaxError
              });
  }

  cpac.user.statement.goToDate = function( _date ) {
    var form = $('filterForm');
    var url = form.action;

    var divID = 'statement-parent-container';

    var selectDateRow = $('filter[period]_row_'+_date);
    if( selectDateRow ) {
        var onclick = selectDateRow.getAttribute('onclick');
        if( onclick ) {
            (function(context, callback){
                callback.call( context )
            })(selectDateRow, function(){
                eval( onclick );
            });
            return;
        }
    }


    resourcesPropertiesForm = form;
    formData = form ? $(form).serialize(true) : {};
    formData['filter[period]'] = _date;

    url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
    if( $('linked-child-accounts') && $F('linked-child-accounts') == -1 ) {
        url += '&view-all-on-account=1';
    }
    showAjaxStarted();


    ajaxDiv = $(divID);
    new Ajax.Request( url, {
        method: 'post',
        parameters: formData,
        onComplete: function(request) {
            showResponse(request, ajaxDiv);
        },
        onFailure: reportAjaxError
    });
}


  cpac.user.billing.catchTrackDefault = function (inputId) {
      if (this.trackCatcher == null) {
          this.trackCatcher = new CcSwipeCatcher({
              fieldId: inputId,
              onComplete: function(isOk, obj) {
                  if (isOk) {
                      var trackField = $j('#' + inputId);
                      var form = trackField.closest('form');

                      form.find('#cc_number').val(obj.PAN);
                      form.find('#cc_name').val(obj.lastName + '/' + obj.firstName);
                      form.find('#cc_date-month').val(obj.expMonth);
                      form.find('#cc_date-year').val('20' + obj.expYear);
                  } else {
                      alert('Swipe was not successfull!');
                  }
              }.bind(this),
              bannerText: 'Waiting for swipe action...',
              cancelText: 'Cancel'
          });
      }
      
      this.trackCatcher.startSwipe();
  }

  cpac.user.billing.catchTrack = function (inputId) {
      var useKeySecureDevice = $j('.js_idtech_start').length;
      
      if (!useKeySecureDevice) {
          this.catchTrackDefault(inputId);
      } else {
          var $form = $j('#' + inputId).closest('form');
          TakePayment.idTechSwipeStart($form, function() {

          });
      }
  }

  cpac.user.billing.getCardsInfo = function() {
      var cardsInfoInput = $j('input[name="cardsInfo"]').val();
      return cardsInfoInput ? $j.parseJSON(cardsInfoInput) : null;
  }

  cpac.user.billing.getAccountsInfo = function () {
    const accountsInfoInput = $j('input[name="accountsInfo"]').val();
    return accountsInfoInput ? $j.parseJSON(accountsInfoInput) : null;
  }


    cpac.user.billing.i4goFrameDialogOpen = function(config) {
      i4goFrameDialogServiceBillingInfo.open(
          function () {},
          {
              i4goIframeDialogOptions: {
                  i4goParamsToFormSelector: '#paymentMethodEditForm',
                  isEmvTerminal: config.isEmvTerminal || false,
                  acceptedPayments: config.acceptedPayments,
                  deviceEntryOnly: config.deviceEntryOnly || false
              }
          }
      );
  }

    cpac.user.billing.initCreditCardAndBankAccountForm = function () {
        const cardsInfo = cpac.user.billing.getCardsInfo();
        const accountsInfo = cpac.user.billing.getAccountsInfo();
        if (cardsInfo?.length) {
            cpac.user.billing.ccMerchantIFrameDialogCall();
        } else if (accountsInfo?.length) {
            cpac.user.billing.BAMerchantIFrameDialogCall();
        }
    }
    cpac.user.billing.initCreditCardForm = function() {
        var cardsInfo = cpac.user.billing.getCardsInfo();
            if (cardsInfo && cardsInfo.length == 1) {
            cpac.user.billing.ccMerchantIFrameDialogCall();
            }
        }

  cpac.user.billing.removeCreditCard = function(params) {
    $j.caPost(
        '/user/payment-method?ajax=true&removePayment=1',
        params,
        function(response) {
            if(response && typeof(response) == 'object') {
                if (response.message) {
                    $j.caAlert(response.message);
                }
                if (response.status == 0) {
                    return; // do not reload form
                }
            }
            location.reload();
        }
    );
  }

  cpac.user.billing.removePayment = function(userId) {
    saveFormData('billingView','billingEdit',
        function() {
            toggleEditForm(null, 'billingView','billingEdit');
            updateProfileMainInfo('/user/profile-maininfo?ajax=1', {id: userId}, '#profile .profile-info');

            var noHcAlert = $j('#no-house-charge-alert');
            if (!noHcAlert.length) {
                return;
            }

            if ($j('house_charge').val() != 'no') {
                noHcAlert.remove();
            }
        },
        {removePayment:true}
    );
  }

    cpac.user.billing.onChangeBankAccount = function (element) {
        const accountId = $j(element).val();
        const accountsInfo = $j.parseJSON($j('input[name="accountsInfo"]').val());
        const paymentUniqueId = $j('input[name="payment_processor_unique_id"]').val();
        if (accountId === '0') {  // To be used for the new bank account. 
            cpac.user.billing.BAMerchantIFrameDialogCall();
        }
        if (!$j.isEmptyObject(accountsInfo[accountId])) {
            $j('#title').val(accountsInfo[accountId]['title']);

            if (accountId != 0) {
                $j('#remove-ba').removeClass('hidden');

                if (accountsInfo[accountId]['is_primary'] != 1) {
                    $j('#set-primary-ba').removeClass('hidden');
                } else {
                    $j('#set-primary-ba').addClass('hidden');
                }
            } else {
                $j('#remove-ba').addClass('hidden');
                $j('#set-primary-ba').addClass('hidden');
            }

        $j('#checking_account_number').val(accountsInfo[accountId]['checking_account_number']);
        $j('#routing_number').val(accountsInfo[accountId]['routing_number']);
        $j('#bank_name').val(accountsInfo[accountId]['bank_name']);
        $j('#bank_state').val(accountsInfo[accountId]['bank_state']);
        $j('#bank_account_type').val(accountsInfo[accountId]['bank_account_type']);
    }
  }
    cpac.user.billing.BAMerchantIFrameDialogCall = function () {
        const cashFlowIsActive = $j('#paymentMethodEditForm [name="cashflowach_active"]').val() === '1';
        if (cashFlowIsActive) {
            cpac.user.billing.cashFlowDialogCallBank();
        }
    }
    cpac.user.billing.cashFlowDialogCallBank = function () {
        let isEmvTerminal = false;
        cashFlowFrameDialogServiceBillingInfoBank.open(
            function (callback, params) {
            },
            {
                cashFlowIframeDialogOptions: {
                    cashFlowParamsToFormSelector: '#paymentMethodEditForm',
                    isEmvTerminal: isEmvTerminal,
                }
            }
        );
    }


  cpac.user.billing.i4goFrameDialogCall = function() {
    var shift4IsActive = $j('#paymentMethodEditForm [name="shift4_active"]').val() === '1';
    var isEmvTerminal = $j('#paymentMethodEditForm [name="is_emv_terminal"]').val() === '1';
    var acceptedPayments = $j('#accepted-payments').val();
    var isP2PEDevice = $j('#isP2PEDevice').val() === '1';
    if (shift4IsActive) {
        cpac.user.billing.i4goFrameDialogOpen({
            isEmvTerminal: isEmvTerminal,
            acceptedPayments: acceptedPayments,
            deviceEntryOnly: isP2PEDevice
        });
    }
}

  cpac.user.billing.cardConnectDialogCall = function(){
      var isEmvTerminal = $j('#paymentMethodEditForm [name="is_emv_terminal"]').val() === '1';
      cardConnectFrameDialogServiceBillingInfo.open(
          function (callback, params) {},
          {
              cardConnectIframeDialogOptions: {
                  cardConnectParamsToFormSelector: '#paymentMethodEditForm',
                  isEmvTerminal: isEmvTerminal,
              }
          }
      );
  }

  cpac.user.billing.cashFlowDialogCall = function () {
        var isEmvTerminal = $j('#paymentMethodEditForm [name="is_emv_terminal"]').val() === '1';
        cashFlowFrameDialogServiceBillingInfo.open(function (callback, params) {
        }, {
            cashFlowIframeDialogOptions: {
                cashFlowParamsToFormSelector: '#paymentMethodEditForm', isEmvTerminal: isEmvTerminal,
            }
        });
    }

    cpac.user.billing.ccMerchantIFrameDialogCall = function () {
        var shift4IsActive = $j('#paymentMethodEditForm [name="shift4_active"]').val() === '1';
        var cardConnectIsActive = $j('#paymentMethodEditForm [name="cardconnect_active"]').val() === '1';
        var cashFlowIsActive = $j('#paymentMethodEditForm [name="cashflow_active"]').val() === '1';
        var cashFlowForMemberIsActive = $j('#billingEdit [name="cashflow_active"]').val() === '1';

        if (shift4IsActive) {
            cpac.user.billing.i4goFrameDialogCall();
        } else if (cardConnectIsActive) {
            cpac.user.billing.cardConnectDialogCall();
        } else if (cashFlowIsActive) {
            cpac.user.billing.cashFlowDialogCall();
        } else if (cashFlowForMemberIsActive) {
            cpac.user.billing.cashFlowDialogCall();
        }

    }

    cpac.user.billing.onChangeCard = function (element) {        
        var activeGatewayAll = document.querySelector('#activeGatewayAll')?.value;
        var houseCharge = jQuery('#house_charge').val();
         if(activeGatewayAll === 'cashflow' && houseCharge === 'credit card'){
              jQuery(".cash_cc_number").prop("readonly", true);
              jQuery(".cash_cc_name").prop("readonly", true);
            }
        var cardId = $j(element).val();
        var cardsInfo = cpac.user.billing.getCardsInfo();
        if (cardId == 0) {
            cpac.user.billing.ccMerchantIFrameDialogCall();
        }
        if (!$j.isEmptyObject(cardsInfo[cardId])) {
            $j('#title').val(cardsInfo[cardId]['title']);

            if (cardId != 0) {
                $j('#remove-cc').removeClass('hidden');

                if (cardsInfo[cardId]['is_primary'] != 1) {
                    $j('#set-primary-cc').removeClass('hidden');
                } else {
                    $j('#set-primary-cc').addClass('hidden');
                }
            } else {
                $j('#remove-cc').addClass('hidden');
                $j('#set-primary-cc').addClass('hidden');
            }

            $j('#cc_number').val(cardsInfo[cardId]['cc_number']);
            $j('#cc_name').val(cardsInfo[cardId]['cc_name']);
            $j('#cc_type').val(cardsInfo[cardId]['cc_type']);
            $j('#cc_date-month').val(cardsInfo[cardId]['cc_date_month']);
            $j('#cc_date-year').val(cardsInfo[cardId]['cc_date_year']);

            $j('#bill_addr_type').val(cardsInfo[cardId]['bill_addr_type']);
            if (cardsInfo[cardId]['bill_addr_type'] == 0) {
                $j('.billing-address').removeClass('hidden');
            } else {
                $j('.billing-address').addClass('hidden');
            }

            $j('#bill_street_address').val(cardsInfo[cardId]['bill_street_address']);
            $j('#bill_street_address2').val(cardsInfo[cardId]['bill_street_address2']);
            $j('#bill_city').val(cardsInfo[cardId]['bill_city']);
            $j('#bill_state').val(cardsInfo[cardId]['bill_state']);
            $j('#bill_zip').val(cardsInfo[cardId]['bill_zip']);
            $j('#available_on_pos').val(cardsInfo[cardId]['available_on_pos']).change();
        }
    }

    cpac.user.accountAccess = {
        toggleRow: function(sender) {
            if( sender ) {
                $(sender).up('.user-row').next('.user-sub-row').toggle();
            }
        }
        ,makeHolder: function( id, name, holderId ) {
            cpac.confirm('Account ownership reassigned to '+name+'. Click YES to confirm.', function() {
                showAjaxStarted();
                $j.get('/user/make-account-holder', {id: id, holder: holderId, ajax: true}, function(error){
                    showAjaxFinished();

                    if( error == '' ) {
                        window.location = '/user/my';
                    } else {
                        $j('#userAccountAccessError').html(error);
                    }
                });
            });
        }
        ,accessToEveryone: function() {
            $$('#userAccountAccessTable .user-row input:enabled:checkbox').each(function(cb){
                cb.checked = true;
                $(cb).fire('toggle:access');
            });
        }
        ,accessToNoOne: function() {
            $$('#userAccountAccessTable .user-row input:enabled:checkbox').each(function(cb){
                cb.checked = false;
                $(cb).fire('toggle:access');
            });
        }
        ,save: function( url ) {
            var form  = $j('#userAccountAccessTable').parent('form');
            var formData = form.serialize();

            url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
            showAjaxStarted();

            new Ajax.Request( url,{
                method: 'post',
                parameters: formData,
                onComplete: function(request) {
                    showAjaxFinished();
                    $('user-account-access').update(request.responseText );
                },
                onFailure: reportAjaxError
            });
        }
        ,changeHolder: function(r) {
            if( r.responseText !== '' ) {
                alert( r.responseText );
            }
        }
    }

}